import axios from 'axios';

const TrackURL = `${process.env.REACT_APP_API_BASE_URL}/track`;

// "Fire and forget" látogatottság-mérő hívás a nyilvános oldalakról (Kezdőlap, Események).
// Sosem szabad hibát dobnia/megszakítania az oldalbetöltést - a hibát csendben elnyeljük.
function trackPageView(path) {
    axios.post(TrackURL, { path }).catch(() => { });
}

export default trackPageView;
